<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`${activeId ? '编辑' : '新增'}设备校准信息`"
    width="900px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="设备名称">
            <el-input disabled v-model.trim="deviceInfo.devName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备编号">
            <el-input disabled v-model.trim="deviceInfo.devCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校准机构" prop="calibrateBy">
            <el-input v-model.trim="editForm.calibrateBy" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校准证书编号" prop="certCode">
            <el-input v-model.trim="editForm.certCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校准日期" prop="checkTime">
            <el-date-picker
              v-model="editForm.checkTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              @change="checkTimeChange"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书有效期至" prop="nxCheckTime">
            <el-date-picker
              v-model="editForm.nxCheckTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="fileList" ref="fileFormItem">
            <UploadButton
              v-model="editForm.fileList"
              :limit="9"
              :fileType="['doc', 'docx', 'pdf', 'png', 'jpg']"
              :paramsData="{ type: 'upt_device_calibrate' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import moment from 'moment';

import UploadButton from '@/components/UploadArea/UploadButton';

import { getDeviceCalibrateById, editDeviceCalibrate } from '@/api/device';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deviceInfo: {
      type: Object,
      default: () => ({})
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {
        calibrateBy: '',
        certCode: '',
        checkTime: '',
        nxCheckTime: '',
        fileList: []
      },
      rules: {
        calibrateBy: [{ required: true, message: '请输入校准机构', trigger: 'blur' }],
        checkTime: [{ required: true, message: '请选择校准日期', trigger: 'change' }],
        nxCheckTime: [{ required: true, message: '请选择证书有效期', trigger: 'change' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.editLoading = true;
      try {
        const { data } = await getDeviceCalibrateById({ id: this.activeId });
        this.editForm = {
          id: data.id,
          certCode: data.certCode,
          calibrateBy: data.calibrateBy,
          checkTime: data.checkTime,
          nxCheckTime: data.nxCheckTime,
          fileList: []
        };
        if (data.fileName) {
          const fileNames = data.fileName.split(',');
          const filePaths = data.filePath.split(',');
          this.editForm.fileList = fileNames.map((fileName, index) => ({
            fileName,
            filePath: filePaths[index]
          }));
        }
      } finally {
        this.editLoading = false;
      }
    },
    checkTimeChange(val) {
      if (val) {
        this.editForm.nxCheckTime = moment(val).add(1, 'years').subtract(1, 'days').format('YYYY-MM-DD');
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const fileName = this.editForm.fileList.map(item => item.fileName).join(',');
          const filePath = this.editForm.fileList.map(item => item.filePath).join(',');

          try {
            await editDeviceCalibrate({
              ...this.editForm,
              deviceId: this.deviceInfo.id,
              devName: this.deviceInfo.devName, //设备名称
              devCode: this.deviceInfo.devCode, //设备编号
              fileName: fileName ?? null,
              filePath: filePath ?? null
            });

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select,
.el-input,
.el-autocomplete {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
